<template>
  <div class="section-box p-2">
    <slot />
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.section-box {
  border: 1px solid $grey11;
}
</style>